import Megamenu from '@/components/header/components/megamenu/megamenu'
import SearchBar from '@/components/header/components/search-bar/search-bar'
import SearchToggle from '@/components/header/components/search-toggle/search-toggle'
import ShoppingCartToggle from '@/components/shopping-cart-toggle/shopping-cart-toggle'
import StorePicker from '@/components/header/components/store-picker/store-picker'

const Header = {
  components: {
    'search-bar': SearchBar,
    'search-toggle': SearchToggle,
    'megamenu': Megamenu,
    'shopping-cart-toggle': ShoppingCartToggle,
    'store-picker': StorePicker
  },
  props: [
    'searchActive',
    'searchInputValue'
  ],
  data () {
    return {
      lastScroll: 0,
      passedDeadzone: false,
      scrollDirection: 'scroll--up',
      megamenu: {
        activeChild: null,
      },
      search: {
        setInputValue: this.searchInputValue,
        showSearch: this.searchActive,
      },
    };
  },
  methods: {
    handleScroll () {
      this.passedDeadzone = window.scrollY > 100

      if (this.passedDeadzone) {
        this.scrollDirection = (window.scrollY <= this.lastScroll)
          ? 'scroll--up'
          : 'scroll--down'
        this.lastScroll = window.scrollY

      } else {
        this.scrollDirection = 'scroll--up'
        this.passedDeadzone = false
      }
    },
    handleResize (windowSize) {
      // Close mobile nav
      if (windowSize.width > 1099) {
        document.querySelector('html').classList.remove('nav-mobile--active')
      }
    },
    handleHover (id) {
      this.megamenu.activeChild = (this.megamenu.activeChild == id)
        ? null
        : id
    },
    toggleMenu (value) {
      bus.$emit('nav_toggled', value)
      this.search.showSearch = false
    },
    toggleSearchVisiblity(toggleState) {
      this.search.showSearch = toggleState
    }
  },
  created () {
    bus.$on('megamenu_toggle', id => {
      this.handleHover(id)
    })
    bus.$on('window_resize', windowSize => {
      this.handleResize(windowSize)
    })
    bus.$on('window_scroll', () => {
      this.handleScroll()
    })
    bus.$on('toggle_header_search', action => {
      switch (action) {
        case 'close':
          this.search.showSearch = false
          break
        case 'open':
          this.search.showSearch = true
          break
        default:
          this.search.showSearch = !this.search.showSearch
      }
    })
  },
}


export default Header
